import React from 'react';

import { Application } from '@ab/ams-school-api/types/private/v1';

type State = {
  application: Application;
};
const context = React.createContext<State | undefined>(undefined);

type ApplicationProviderProps = {
  application: Application;
  children: React.ReactNode;
};
export function ApplicationProvider(props: Readonly<ApplicationProviderProps>) {
  const value = React.useMemo<State>(() => {
    return {
      application: props.application,
    };
  }, [props.application]);

  return <context.Provider value={value}>{props.children}</context.Provider>;
}
export function useApplication() {
  const state = React.useContext(context);
  if (!state) throw new Error('useApplication should be used within <ApplicationProvider />');
  return state;
}
